import React from "react";
import Slider from "./slieder";
import { motion } from "framer-motion";
import FooterwithoutLogin from "./footerwithoutLogin";
import SEO from "../SEO/seo";

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0 },
};

const scaleFade = {
  hidden: { opacity: 0, scale: 0.9 },
  visible: { opacity: 1, scale: 1 },
};

const imageZoom = {
  hidden: { scale: 1.05, opacity: 0 },
  visible: { scale: 1, opacity: 1 },
};

const slideLeftToRight = {
  hidden: { opacity: 0, x: -100 },
  visible: { opacity: 1, x: 0 },
};

const slideRightT0Left = {
  hidden: { opacity: 0, x: 100 },
  visible: { opacity: 1, x: 0 },
};

function EmployeeTranning() {
  return (
    <>
      <SEO
        title="Employee Training Programme | Kryzen Biotech Farm Skill Development"
        description="At Kryzen Biotech, every Farm Development Service includes a hands-on Employee Training Programme — designed to empower your team with the skills, confidence, and expertise to run a successful hydroponic farm."
        keywords="employee training hydroponics, kryzen biotech training, farm staff development, hydroponic farm training, agriculture skill building, hydroponic workforce training, commercial farm employee programme"
        canonical="https://alpha.kryzen.com/kryzen-employee-tranning"
        ogTitle="Employee Training Programme | Kryzen Biotech Farm Skill Development"
        ogDescription="Kryzen Biotech offers comprehensive employee training with every farm setup — ensuring your team is skilled, confident, and ready to manage hydroponic operations successfully."
        ogImage="https://res.cloudinary.com/bsgfcooa/image/upload/v1752559406/3_exlvdj_ancfou_i1xcah.png"
        twitterTitle="Employee Training Programme | Kryzen Biotech Farm Skill Development"
        twitterDescription="Kryzen’s Employee Training Programme helps build skilled teams for hydroponic farming success — included with every commercial farm development service."
      />
      <div>
        <Slider
          heding={"Employee Training Programme"}
          paragraph={
            "At Kryzen Biotech, we believe that the success of a hydroponic farm lies not just in the setup but in the people who run it. That’s why, with every Farm Development Service you receive from us, we provide a comprehensive Employee Training Programme designed to build skills, confidence, and expertise in your team."
          }
        ></Slider>
        <div className="container mainDiv py-5">
          <div className="text-center py-5 px-3">
            <motion.h1
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.3 }}
              variants={fadeUp}
              transition={{ duration: 0.7 }}
              className="display-md-4 display-lg-4 display-5 fw-bold text-uppercase text-success mb-2"
            >
              Empowering Your Team with Hydroponic Expertise
            </motion.h1>

            <hr></hr>
            <motion.p
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.3 }}
              variants={fadeUp}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="lead mx-auto p-5"
              style={{ lineHeight: "1.8", fontSize: "25px" }}
            >
              At Kryzen Biotech, we believe that the success of a hydroponic
              farm lies not just in the setup but in the people who run it.
              That’s why, with every Farm Development Service you receive from
              us, we provide a comprehensive Employee Training Programme
              designed to build skills, confidence, and expertise in your team.
            </motion.p>
          </div>

          <div className="text-center py-5 px-3 mt-7">
            <motion.h1
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.3 }}
              variants={fadeUp}
              transition={{ duration: 0.7 }}
              className="display-md-4 display-lg-4 display-6 fw-bold text-uppercase"
            >
              What’s Included
            </motion.h1>

            <hr></hr>
          </div>

          <div className="row g-5 align-items-stretch">
            {/* Left Column */}
            <div className="col-md-6">
              <motion.div
                className="card border-0 h-100 p-3"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false, amount: 0.3 }}
                variants={slideLeftToRight}
                transition={{ duration: 0.5, delay: 0.2 }}
              >
                <div className="card-body p-4">
                  <h5 className="card-title fs-3 fw-semibold mb-3 text-primary">
                    1. Hydroponic Masterclass Access
                  </h5>
                  <motion.p
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.3 }}
                    variants={fadeUp}
                    transition={{ duration: 0.6, delay: 0.2 }}
                    className="card-text text-secondary"
                    style={{ lineHeight: "1.8", fontSize: "1.05rem" }}
                  >
                    Get 3 complimentary user access codes to our exclusive
                    online Hydroponic Masterclass — a structured learning
                    platform curated by our experts. Your staff can explore
                    step-by-step guidance, video tutorials, and real-world case
                    studies covering the entire hydroponic farming ecosystem.
                  </motion.p>
                  <a
                    className="btn btn-primary btn-sm"
                    href="https://www.hydroponicmasterclass.com/"
                    target="_blank"
                  >
                    Explore hydroponic masterclass!
                  </a>
                </div>
              </motion.div>
            </div>
            {/* Right Column */}
            <div className="col-md-6">
              <motion.div
                className="card border-0 h-100 p-3"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false, amount: 0.3 }}
                variants={slideRightT0Left}
                transition={{ duration: 0.5, delay: 0.2 }}
              >
                <div className="card-body p-4">
                  <h5 className="card-title fs-3 fw-semibold mb-3 text-primary">
                    2. Hands-On Training at Our Farm
                  </h5>
                  <motion.p
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.3 }}
                    variants={fadeUp}
                    transition={{ duration: 0.6, delay: 0.2 }}
                    className="card-text text-secondary"
                    style={{ lineHeight: "1.8", fontSize: "1.05rem" }}
                  >
                    Want your team to experience hydroponics in action? Send
                    your workers or supervisors to our demonstration farm for a
                    real-time learning experience. They'll interact directly
                    with hydroponic systems, nutrient management practices, and
                    crop care techniques under expert supervision.
                  </motion.p>
                  <a
                    className="btn btn-primary btn-sm"
                    href="https://kryzen.com/farm-training/"
                    target="_blank"
                  >
                    Explore Farm Training Programs!
                  </a>
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </div>
      <FooterwithoutLogin></FooterwithoutLogin>
    </>
  );
}

export default EmployeeTranning;
